module.exports = __webpack_public_path__ + "img/09.a0d498f0.png";